import { render, staticRenderFns } from "./Logout.html?vue&type=template&id=72a0b38b&scoped=true&"
import script from "./Logout.js?vue&type=script&lang=js&"
export * from "./Logout.js?vue&type=script&lang=js&"
import style0 from "./Logout.scss?vue&type=style&index=0&id=72a0b38b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0b38b",
  null
  
)

export default component.exports